<template>
  <div :class="[
    'mb-4',
    size <= 6
      ? 'col-xl-'+size+' col-md-'+size*2
      : size > 6
      ? 'col-xl-'+size+' col-md-12'
      :'col-xl-3 col-md-6',
  ]">
    <div class="card">
      <div :class="[
        'card-header',
        'card-header-text',
        'pt-3',
        'pb-1',
        'px-2',
        'mx-0',
        color == 'primary'
          ? 'bg-primary'
          : color == 'success'
          ? 'bg-success'
          : color == 'info'
          ? 'bg-info'
          : color == 'warning'
          ? 'bg-warning'
          : color == 'danger'
          ? 'bg-danger'
          : 'bg-info',
      ]">
        <h4 class="card-title text-xs text-center font-weight-bold text-uppercase text-light">{{ nameCard }}</h4>
      </div>

      <div class="card-body">
        <div class="row no-gutters align-items-center">
          <div class="col">
            <div class="h5 mb-0 font-weight-bold text-dark" align="center">
              {{ amount }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["nameCard", "amount", "color", "size"],
};
</script>
<style></style>